import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './Styles/App.scss';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Cookies from './components/Cookies';
import Footer from './components/Footer';
import { SidebarProvider } from './context/SidebarContext';





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <SidebarProvider>
    <Cookies />
    <Header />
  <Sidebar />
    <App />
    <ToastContainer />
    </SidebarProvider>
  </BrowserRouter>
  </React.StrictMode>
);
